export declare namespace AppSectionTokenSections {
	interface Header {
		background: string;
		padding: string;
		fontSize: string;
		lineHeight: string;
		fontWeight: string;
	}
}

export type AppSectionTokens = {
	gap: string;
	header: AppSectionTokenSections.Header;
};

export const header: AppSectionTokenSections.Header = {
	background: '{primary.50}',
	padding: '0.5rem',
	fontSize: '16px',
	lineHeight: '26px',
	fontWeight: '700',
};

export default {
	gap: '1.5rem',
	header,
} satisfies AppSectionTokens;
